import React, {useState} from "react";
import {
  TextField,
  Button,
  IconButton
} from "@mui/material";
import * as _ from 'lodash'

import { gas_types } from "../../constants/common";
import SwitchCustom from '../switch';
import RadioButton from "../radio";

const ChargeInfo = ({chargeOption, type, charge, isDialog = false, onCancel}) => {
  const [amount, setAmount] = useState('');
  const [repeat, setRepeat] = useState(false);
  const [repeatDay, setRepeatDay] = useState(7);
  const [location, setLocation] = useState({})

  const getTitle = () => {
    return chargeOption === 'togrog' ? "Мөнгөн дүн" : "Литрийн дүн"
  }

  const getFields = () => {
    if (chargeOption === 'togrog') {
      return <TextField
        className="w-100"
        label="0.00₮"
        variant="outlined"
        value={amount}
        type={"number"}
        onChange={(e) => setAmount(e.target.value)}
      />
    } else {
      return <div className="d-flex">
        <select defaultValue={0} 
          className="form-select custom-dropdown w-auto ms-2">
          {
            gas_types.map((g, i) => (
              <option key={`gas_types_${g}`} value={g}>{g}</option>
            ))
          }
        </select>
        <TextField
          className="flex-grow-1"
          label="0л"
          variant="outlined"
          value={amount}
          type={"number"}
          onChange={(e) => setAmount(e.target.value)}
        />
      </div>
    }
  }

  const getDesc = () => {
    if (chargeOption === 'togrog') {
      if (type === 0) return {
        'Жолоочийн тоо': 3,
        'Нэг жолоочид': '5’000₮',
      } 
      else if (type === 1) return {
        'Оруулсан үнэ': '5’000₮',
        'Жолоочийн тоо': 3,
        'Нэг жолоочид': '5’000₮',
      }
    } else {
      return {
        'Жолоочийн тоо': 3,
        'Литрийн дундаж үнэ': '5’000₮',
        'Нэг жолоочид': '5’000₮', 
      }
    }
  }

  const locationSection = () => {
    if(chargeOption === 'litre') 
    return (
      <>
        {
          !_.isEmpty(location) && <div className="d-flex mt-4">
            <div className="icon-container">
              <img alt="office" src="/images/office.svg" height={12} />
            </div>
            <div className="d-flex me-3 pb-2 border-bottom-container">
              <div className="ms-3 font-size-14 font-weight-400">
                <div className="text-primary">{location.name}</div>
                <div className="text-grey font-size-12">{location.location}</div>
              </div>
              <div className="mt-n2">
                <RadioButton checked={true}/>
              </div>
            </div>
          </div>
        }
        <Button
          className="btn-bordered btn-bordered-white w-100 px-9 mt-3 mx-sm-0"
          variant="contained"
          disableElevation
          onClick={onClickLocation}
          startIcon={<img alt="pin" src="/images/pin_drop.svg" height={16} />}
        >
          <span className="font-weight-500">Байршил сонгох</span>
        </Button>
      </>
    )
  }

  const onClickLocation = () => {
    setLocation({name: 'Шунхлай төв оффис', 
      location: 'Хан-уул дүүрэг, 15-р хороо, APU барилга, 1-р давхар, 0000 тоот, 2-р өрөө'})
  }

  return (
    // <div className="d-flex flex-column charge-info">
    <>
      <div className={`charge-info-head ${!isDialog ? 'py-3' : ''}`}>
        Цэнэглэх картууд
        {
          isDialog && <IconButton key="2-3" className="fab-btn" onClick={onCancel}>
            <img alt="close" src="/images/close.svg" height={16} width={16} />
          </IconButton>
        }
      </div>
      <div className="charge-info-body bg-white">
        <div className="mb-3 font-size-16 font-weight-bold">{getTitle()}</div>
        { getFields() }
        { locationSection() }
        <div className="bordered mt-4">
          <div className="d-flex align-items-center justify-content-between p-3">
            <div className="font-weight-500 font-size-16">Давтан цэнэглэлт</div>
            <SwitchCustom
              value={repeat}
              handleChange={(e) => setRepeat(e.target.checked)}
            />
          </div>
          {repeat && (
            <div className="charge-info-repeat-section p-3">
              <div className="font-weight-500">Цэнэглэлт хийх хугацаа</div>
              <div className="text-grey">{repeatDay} хоног</div>
              <div className="mt-3 d-flex justify-content-around justify-content-lg-between">
                {
                  [7,14,30].map(d => (
                    <Button
                      key={`buttons-${d}`}
                      onClick={() => setRepeatDay(d)}
                      className={`ms-1 charge-info-button btn-bordered ${repeatDay === d ? "bg-primary" : "btn-bordered-white"}`}
                      variant="contained"
                      disableElevation
                    >
                      {d} хоног
                    </Button>
                  ))
                }
              </div>
            </div>
          )}
        </div>
        <div className="bordered mt-4 font-weight-500 py-3">
          {
            Object.entries(getDesc()).map(([key, value]) => (
              <div key={`desc-${key}`} className="d-flex align-items-center justify-content-between px-3 py-1">
                <div>{key}</div>
                <div>{value}</div>
              </div>
            ))
          }
          <hr />
          <div className="d-flex align-items-center justify-content-between px-3 py-1">
            <div className="text-primary">Нийт дүн:</div>
            <div className="text-primary">-50’000₮</div>
          </div>
        </div>
        <div className="warning-container mt-4">
          Цэнэглэлт хийх картын түгжсэн бүтээгдхүүн зөрж байна. Түгжсэн
          бүтээгдхүүнээс бусадыг нь цэнэглэх үү?
        </div>
      </div>
      <div className="footer">
        <Button
          onClick={charge}
          className="bg-primary btn-bordered w-100"
          variant="contained"
          disableElevation
          startIcon={<i className="bx bx-plus"></i>}
        >
          Дэд карт цэнэглэх
        </Button>
      </div>
    </>
  );
};


export default ChargeInfo